import { GranularityType } from 'types/dates-types';

export const DEFAULT_GRANULARITY: GranularityType = 'week';
export const DEFAULT_COMPARE_GRANULARITY: GranularityType = 'prev';
